export default __webpack_public_path__ + "static/media/b.4ef24370.png";